export function getStringOrBlank(value?: string | null) {
  return value ? sanitizeInput(value) : '';
}

export function getNullableString(value?: string | null) {
  return value || null;
}

export const sanitizeInput = (text: string) => {
  const cleaned = text
    // Replace em-dash (—) and en-dash (–) with a standard hyphen
    .replaceAll(/[\u2014\u2013]/g, '-')
    // Replace left/right smart double quotes with standard double quotes
    .replaceAll(/[\u201C\u201D]/g, '"')
    // Replace left/right smart single quotes/apostrophes with standard single quote
    .replaceAll(/[\u2018\u2019]/g, "'");
  return cleaned;
  // If things escalate - strip out complex symbols/alt-codes entirely, leaving only standard keyboard characters
  // .replace(/[^\x20-\x7E]/g, '');
};

export const nonEmpty = (value?: string) => (value?.trim() ? value : undefined);
